import { render, staticRenderFns } from "./TermMonitor.vue?vue&type=template&id=0f4af45e&scoped=true&"
import script from "./TermMonitor.vue?vue&type=script&lang=js&"
export * from "./TermMonitor.vue?vue&type=script&lang=js&"
import style0 from "./TermMonitor.vue?vue&type=style&index=0&id=0f4af45e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4af45e",
  null
  
)

export default component.exports